export default "__VITE_ASSET__CVgaQy92__"